export const ARE_YOU_SURE_YOU_WANT_TO_TEXT = {
    description: 'Warning message',
    defaultMessage: 'Are you sure you want to',
    id: 'oe.warnings.areYouSureTo'
};
export const DELETE_THIS_EVENT_ATTRIBUTE_TEXT = {
    description: 'Warning message',
    defaultMessage: 'delete this event attribute',
    id: 'oe.eventAttribute.deleteThisEventAttribute'
};
export const DELETE_EVENT_ATTRIBUTE_TEXT = {
    description: 'Label text',
    defaultMessage: 'Delete Event Attribute',
    id: 'oe.eventAttribute.deleteEventAttribute'
};
export const EVENT_ATTRIBUTE_IN_USE_TEXT = {
    description: 'Warning message',
    defaultMessage: 'This Event Attribute is being used on {count} Event(s). Please remove the Event Attribute from these Event(s) before deleting.',
    id: 'oe.eventAttribute.attributeInUse'
};
export const OK_TEXT = {
    description: 'Button text',
    defaultMessage: 'Ok',
    id: 'oe.common.ok'
};
